module.exports = __webpack_public_path__ + "img/brand-03.3384d0c1.png";